<template>
	<li
		class="sidebar-cart__list-item sidebar-cart__list-item--configurable"
		:class="{
			'sidebar-cart__list-item--editable': editable,
			'sidebar-cart__list-item--restricted': restricted,
		}"
	>
		<div class="sidebar-cart__list-item-info">
			<div class="sidebar-cart__list-item-info-wrapper">
				<span
					class="sidebar-cart__list-item-name"
					v-html="item.detailedName || item.name"
				/>
				<span
					class="sidebar-cart__list-item-meta"
					v-if="item.variant && !item.detailedName"
					v-html="item.variant"
				/>
			</div>
			<!-- TODO: this should be replaced with the variant name of the item, i.e. Standard Bun -->
			<button
				v-if="hasFeature('FEATURE_CART_ITEM_NOTES') && !item.disableNote"
				class="sidebar-cart__list-item-notes"
				:class="{
					'sidebar-cart__list-item-notes--active': item.notes
				}"
				:title="item.notes ? $t('cart.notes.buttonTitleActive') : $t('cart.notes.buttonTitleEmpty')"
				@click="$emit('notes')"
				:disabled="locked || !editable || restricted"
			>
				<SVGNote/>
			</button>
		</div>

		<div class="sidebar-cart__list-item-quantity">
			<button
				class="sidebar-cart__list-item-quantity-minus"
				@click="$emit('remove')"
				:disabled="locked || !editable || restricted"
			>
				<SVGTrash/>
			</button>
			<span
				class="sidebar-cart__list-item-quantity-value"
			/>
			<button
				class="sidebar-cart__list-item-quantity-plus"
				@click="$emit('copy')"
				:disabled="locked || !editable || restricted"
			>
				<SVGDuplicate/>
			</button>
		</div>

		<span
			class="sidebar-cart__list-item-price"
			v-html="$options.filters.fwgpricecent(item.originalTotal, 'short')"
		/>

		<div
			class="sidebar-cart__list-item-details"
		>
			<a
				v-if="childCount"
				class="sidebar-cart__list-item-options-trigger"
				:class="{
					'sidebar-cart__list-item-options-trigger--open': showOptions
				}"
				v-html="optionsTrigger"
				@click.prevent="toggleOptions"
			/>
			<Button
				class="sidebar-cart__list-item-edit"
				type="button"
				level="tertiary"
				:text="$t('cart.itemEdit')"
				arrow
				:disabled="locked || !editable || outside || restricted"
				@click.prevent="$emit('edit')"
			/>
			<div
				v-if="childCount && showOptions"
				class="sidebar-cart__list-item-options-wrapper"
			>
				<div
					class="sidebar-cart__list-item-options"
					v-if="selectedOptions"
					v-html="selectedOptions"
				/>
				<div
					class="sidebar-cart__list-item-extras"
					v-if="selectedExtras"
				>
					<span
						class="sidebar-cart__list-item-subtitle"
						v-if="selectedOptions"
						v-html="$t('childproducts.extrasTitle')"
					/>
					<span
						class="sidebar-cart__list-item-options"
						v-html="selectedExtras"
					/>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
import QuantityCounter from '@/components/QuantityCounter';
import Button from '@/components/Button';

export default {
	components: {
		QuantityCounter,
		Button,
	},
	props: {
		item: Object,
		locked: Boolean,
		editable: Boolean,
		restricted: Boolean,
		outside: Boolean,
	},
	data() {
		return {
			showOptions: false,
		}
	},
	computed: {
		selectedChildrenByType() {
			return this.item.children.reduce((acc, child) => {
				if (!Array.isArray(acc[child.type])) {
					acc[child.type] = [];
				}

				acc[child.type].push(child.name);
				return acc;
			}, {});

		},
		optionsCount() {
			return (this.selectedChildrenByType.option?.length || 0);
		},
		extrasCount() {
			return (this.selectedChildrenByType.extra?.length || 0);
		},
		childCount() {
			return this.optionsCount + this.extrasCount;
		},
		optionsTrigger() {
			if (this.optionsCount && !this.extrasCount) {
				return this.$tc('childproducts.optionsCount', this.optionsCount, { count: this.optionsCount});
			}
			else if (!this.optionsCount && this.extrasCount) {
				return this.$tc('childproducts.extrasCount', this.extrasCount, { count: this.extrasCount});
			}
			else if (this.optionsCount && this.extrasCount) {
				return this.$t('childproducts.optionsExtrasCount', { count: this.childCount});
			}
			return '';
		},
		selectedOptions() {
			return this.selectedChildrenByType.option ?
				this.selectedChildrenByType.option.join(', ') :
				'';
		},
		selectedExtras() {
			return this.selectedChildrenByType.extra ?
				this.selectedChildrenByType.extra.join(', ') :
				'';
		},
	},
	methods: {
		toggleOptions() {
			this.showOptions = !this.showOptions;
		}
	},
	mounted() {
		const parent = this.$el.parentNode;
		parent.scrollTop = parent.scrollHeight;
	}
}
</script>

<style>

</style>
